import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { Bookmark, Eye } from 'react-feather';

const NewsItemList = ({ imageUrl, name, typeName, description, last, newsId, date, seenCount }) => {
    const [isHover, setHover] = useState(false);

    const { t } = useTranslation();

    const handleMouseEnter = (e) => {
        setHover(true);
    };

    const handleMouseLeave = () => {
        setHover(false);
    };

    return (
        <Box
            className={[`relative`]}
            style={{
                boxShadow: '0 0 30px rgba(31, 45, 61, 0.125)',
                borderRadius: 4,
                marginBottom: 50,
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Link href={'/news/' + newsId} passHref>
                <Box
                    style={{
                        height: '430px',
                        overflow: 'hidden',
                        borderRadius: 4,
                        position: 'relative',
                        cursor: 'pointer',
                    }}
                >
                    <Box
                        style={{
                            width: '100%',
                            height: '100%',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundImage: `url(${imageUrl})`,
                            transform: isHover ? 'scale(1.06)' : 'none',
                            transition:
                                'margin-bottom 0.3s ease-in-out, margin-top 0.3s ease-in-out, height 0.3s ease-in-out, box-shadow 0.3s ease-in-out, transform 0.5s ease-in-out',
                        }}
                    ></Box>
                </Box>
            </Link>
            <Box
                style={{
                    // boxShadow: '0 0 30px rgba(31, 45, 61, 0.125)',
                    // borderRadius: 5,
                    // backgroundColor: '#fff',
                    padding: 15,
                    // margin: '-30px 20px 0',
                    position: 'relative',
                }}
            >
                <Link href={'/news/' + newsId} passHref>
                    <Typography
                        variant="subtitle3"
                        className="absolute cursor-pointer"
                        style={{
                            color: 'white',
                            backgroundColor: '#0051d2',
                            top: -45,
                            left: 45,
                            width: 90,
                            height: 90,
                            textAlign: 'center',
                            padding: '8px 15px',
                            fontSize: 24,
                            borderRadius: 4,
                        }}
                    >
                        {date}
                    </Typography>
                    <Typography variant="h3" className="font-bold mt-10 px-4 cursor-pointer">
                        {name}
                    </Typography>
                </Link>
                <Box className="flex flex-row justify-start px-4 py-6 items-center ">
                    <Bookmark color={'#999999'} size={'17'} />
                    <Typography variant="body2" className=" ml-1" style={{ color: '#999999' }}>
                        {typeName}
                    </Typography>
                    <Box
                        style={{
                            borderLeft: '1px solid',
                            borderColor: '#999999',
                            height: 16,
                            marginLeft: 10,
                            marginRight: 10,
                        }}
                    ></Box>
                    <Eye color={'#999999'} size={'17'} />

                    <Typography variant="body2" className=" ml-1" style={{ color: '#999999' }}>
                        {`${t('seen')} ${seenCount}`}
                    </Typography>
                </Box>
                {/* <Typography variant="body2">{description}</Typography> */}
            </Box>
        </Box>
    );
};

export default NewsItemList;
